
WL.registerComponent('handle-grabbed', {
    what: {type: WL.Type.Enum, values: 
        ['gift','paper','ribbon'], default: 'gift'},
    detail: {type: WL.Type.Enum, values: 
        ['train','star','candy','chest','horse',
        'xmas','red','yellow','blue','green','purple'], default: 'train'}
}, {
    init(){
        this.whatList = ['gift','paper','ribbon'];
        this.detailList = ['train','star','candy','chest','horse','xmas','red','yellow','blue','green','purple'];
        this.isGrabbed = false;
    },
    start: function () {
        let grabbable = this.object.getComponent('grabbable');
        grabbable.registerGrabEventListener(this, this.onGrab.bind(this));
        grabbable.registerUngrabEventListener(this, this.onUngrab.bind(this));
        
        window.SW.gameState.cryingKidsSubject.subscribe((v)=>{
            if(v>=5){
                if(this.isGrabbed){
                    grabbable._ungrab();
                }
            }
        });
        
    },
    onGrab(grabber) {                   
        this.lastGrabber = grabber;
        this.isGrabbed = true;
        window.SW.gameState.grab({
            type:this.whatList[this.what],
            subtype:this.detailList[this.detail],
            grabber:grabber
        });
    },
    onUngrab() {        
        this.lastGrabber = null;
        this.isGrabbed = false;
        window.SW.gameState.ungrab({
            type:this.whatList[this.what],
            subtype:this.detailList[this.detail]
        });
        
    }
});
